<template>
  <v-dialog v-model="dialog" max-width="600px" persistent @keydown.esc="cancel">
    <v-card>
      <v-card-title>
        <span class="headline">{{ title }}</span>
      </v-card-title>
      <v-card-text>
        <div class="unlock-dialog-message">{{ message }}</div>
        <v-text-field
          v-if="showReason"
          v-model="reason"
          label="Reason (optional)"
          hint="Recorded in the audit history"
          persistent-hint
          autofocus
          @keydown.enter="agree">
        </v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="mr-4" color="primary" outlined rounded @click.native="cancel">Cancel</v-btn>
        <v-btn color="primary" rounded @click.native="agree">{{ okText }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
/**
 * Promise based confirm dialog with an optional reason field
 *
 * <unlock-dialog ref="unlockDialog"></unlock-dialog>
 *
 * const result = await this.$refs.unlockDialog.open('Unlock User', 'Unlock Bob?', {okText: 'Unlock'})
 * result is null when cancelled, otherwise {reason}
 */
export default {
  data() {
    return {
      dialog: false,
      title: '',
      message: '',
      okText: 'OK',
      showReason: true,
      reason: '',
      resolve: null
    }
  },
  methods: {
    open(title, message, {okText = 'OK', showReason = true} = {}) {
      this.title = title
      this.message = message
      this.okText = okText
      this.showReason = showReason
      this.reason = ''
      this.dialog = true
      return new Promise(resolve => {
        this.resolve = resolve
      })
    },
    agree() {
      this.dialog = false
      this.resolve({reason: this.reason})
    },
    cancel() {
      this.dialog = false
      this.resolve(null)
    }
  }
}
</script>
<style scoped>
  .unlock-dialog-message {
    white-space: pre-line;
  }
</style>
